import { render, staticRenderFns } from "./redBox.vue?vue&type=template&id=f99be6d4&"
import script from "./redBox.vue?vue&type=script&lang=js&"
export * from "./redBox.vue?vue&type=script&lang=js&"
import style0 from "./redBox.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports